/**
 * @typedef {import('./RootStore').RootStore} RootStore
 */
import PropTypes from 'prop-types'
import { createContext, useContext } from 'react'
import rootStore from './RootStore'

/** @type {import('./RootStore').RootStore} */
const RootStoreContext = createContext(rootStore)

export const RootStoreProvider = RootStoreContext.Provider

export const useStores = () => {
  const context = useContext(RootStoreContext)
  return /** @type {RootStore} */ (context)
}

RootStoreProvider.propTypes = {
  value: PropTypes.object.isRequired,
}
